export default __webpack_public_path__ + "static/media/new-ai-logo-white.dd8c83a7.svg";